import { render } from "./DropdownCompany.vue?vue&type=template&id=734c04d7"
import script from "./DropdownCompany.vue?vue&type=script&lang=js"
export * from "./DropdownCompany.vue?vue&type=script&lang=js"

import "./DropdownCompany.vue?vue&type=style&index=0&id=734c04d7&lang=scss"

import exportComponent from "/Volumes/Storage/WebDevelopment/Fintax/new-gitlab/pajak.io/frontend-library-component-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__